import type { RouteRecordRaw } from 'vue-router';

export const orgRoutes: Array<RouteRecordRaw> = [
  {
    path: '/org',
    name: 'org',
    redirect: '/organization/list',
    component: () => import('pages/central/organization/McOrganization.vue'),
    meta: {
      title: 'Organizations',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/organization',
    name: 'organization',
    redirect: '/organization/list',
    component: () => import('pages/central/organization/McOrganization.vue'),
    meta: {
      title: 'Organizations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'organizationList',
        component: () => import('pages/central/organization/OrganizationList.vue'),
        meta: {
          title: 'Organizations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'organizationDetail',
        component: () => import('pages/central/organization/OrganizationDetail.vue'),
        meta: {
          title: 'Organization Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'organizationNew',
        component: () => import('pages/central/organization/OrganizationNew.vue'),
        meta: {
          title: 'New Organization',
          requiresAuth: true,
        },
      },
      {
        path: 'contact',
        name: 'orgContact',
        redirect: 'contact/list',
        component: () => import('pages/central/organization/contact/OrgContact.vue'),
        meta: {
          title: 'Organization: Contacts management',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'orgContactList',
            component: () => import('pages/central/organization/contact/ContactList.vue'),
            meta: {
              title: 'Organization: Contacts List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'orgContactDetail',
            component: () => import('pages/central/organization/contact/ContactDetail.vue'),
            meta: {
              title: 'Organization: Contact Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'orgContactNew',
            component: () => import('pages/central/organization/contact/ContactNew.vue'),
            meta: {
              title: 'Organization: New Contact',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
